<div class="map-drawing-controls">
  <div class="drawing-controls-container flex-{{ direction }}">
    <button
      type="button"
      class="draw-btn"
      [class.active]="distanceActive"
      (click)="toggleDistance.emit()"
      [title]="'Measure Distance' | translate">
      <img class="ruler-icon" src="assets/icons/main/light/ruler.svg" width="20" height="20"
           [alt]="'Measure Distance' | translate">
    </button>

    <button
      type="button"
      class="draw-btn"
      [class.active]="rectangleActive"
      (click)="enableRectangle.emit()"
      [title]="'DRAW_RECTANGLE' | translate">
      <img src="assets/icons/main/light/square.svg" width="20" height="20" alt="Rectangle">
    </button>

    <button
      type="button"
      class="draw-btn"
      [class.active]="polygonActive"
      (click)="enablePolygon.emit()"
      [title]="'DRAW_POLYGON' | translate">
      <img src="assets/icons/main/light/sixers.svg" width="20" height="20" alt="Polygon">
    </button>

    <button
      type="button"
      class="draw-btn"
      [class.active]="boxPolygonActive"
      (click)="enableBoxPolygon.emit()"
      [title]="'DRAW.BOX_POLYGON' | translate">
      <img src="assets/icons/main/light/rectangle-measure.svg" width="20" height="20" alt="Box Polygon">
    </button>

    <button
      type="button"
      class="draw-btn"
      [class.active]="customPolygonActive"
      (click)="enableCustomPolygon.emit()"
      [title]="'DRAW.CUSTOM_POLYGON' | translate">
      <img src="assets/icons/main/light/polygon-measure.svg" width="20" height="20" alt="Custom Polygon">
    </button>

    <button
      type="button"
      class="draw-btn"
      (click)="clearAllDrawings.emit()"
      [title]="'Clear All Drawings' | translate"
      style="margin-left: 8px;">
      <img src="assets/icons/main/light/eraser.svg" width="20" height="20" alt="Clear All">
    </button>

    <button
      type="button"
      class="draw-btn"
      (click)="openGeoUpload.emit()"
      [title]="'Upload Geo File' | translate">
      <img src="assets/icons/main/light/upload-geo.svg" width="20" height="20" alt="Upload Geo File">
    </button>

    <div class="visibility-tool-wrapper">
      <button
        type="button"
        class="draw-btn"
        [class.active]="visibilityManager.menuOpen"
        (click)="visibilityManager.toggleMenu($event)"
        [title]="'MAP_VISIBILITY.TOOL_TITLE' | translate">
        <i class="pi pi-eye"></i>
      </button>
      @if (visibilityManager.menuOpen) {
        <div class="visibility-popover" (click)="$event.stopPropagation()">
          <div class="visibility-popover-title">{{ 'MAP_VISIBILITY.TOOL_TITLE' | translate }}</div>
          <div class="visibility-checkbox-stack">
            <app-checkbox
              [ngModel]="visibilityManager.showRegionNames"
              (ngModelChange)="visibilityManager.setShowRegionNames($event)"
              [label]="'MAP_VISIBILITY.SHOW_REGION_NAMES'"
              size="medium"
              color="primary"
            ></app-checkbox>
            <app-checkbox
              [ngModel]="visibilityManager.polygonFillVisible"
              (ngModelChange)="visibilityManager.setPolygonFillVisible($event)"
              [label]="'MAP_VISIBILITY.FILL_POLYGONS'"
              size="medium"
              color="primary"
            ></app-checkbox>
          </div>
        </div>
      }
    </div>
  </div>
</div>
